/**
 * @name historySlider
 * @memberOf routes:mapping
 * @ngdoc directive
 * @description
 *
 * Slider for historical map data
 *
 * @example <history-slider map="map" max-date-range="maxDateRange"></history-slider>
 *
 * @param {L.Map} map a Leaflet map object
 * @param {Object} maxDateRange expected to a Moment date ranges as such: `{ minDate: Moment, maxDate: Moment }`
 * @param {Moment} maxDateRange.minDate a Moment date object
 * @param {Moment} maxDateRange.maxDate a Moment date object
 * @param {integer} mode either 1 or 2, depending on which slider is wanted (i.e., 1 for a single point slider, 2 for a two point slider)
 *
 * @see {@link routes_mapping.OnePointHistorySlider}
 * @see {@link routes_mapping.TwoPointHistorySlider}
 */

angular.module("routes:mapping").directive("historySlider", function (HistorySlider, $timeout) {
  return {
    scope: {
      map: "=",
      maxDateRange: "=",
      dateRange: "=ngModel",
      mode: "=",
      interval: "=",
    },
    require: "ngModel",
    link: function ($scope, $element, $attrs, $model) {
      /**
       * This holds the control after it's been initialized
       */
      let control;

      /**
       * Creates the slider
       * @param  {integer} mode the slider mode to create
       * @return {void}
       */
      function initialize(mode) {
        control = HistorySlider();

        // Make sure the slider updates the model
        control.on("change", function (data) {
          $model.$setViewValue(data.range);
        });

        control.addTo($scope.map);
      }

      /**
       * Runs when settings are changed
       * @return {void}
       */
      function updateControlSettings() {
        // Don't try to work on an uninitialized control
        if (!control) return;

        control.initialize({
          minDate: $scope.dateRange.minDate || $scope.maxDateRange.minDate,
          maxDate: $scope.dateRange.maxDate || $scope.maxDateRange.maxDate,
          range: $scope.maxDateRange,
          mode: $scope.mode,
          interval: $scope.interval, // only used for single point sliders
        });
      }

      /**
       * Check that two date ranges are equal, even if the objects aren't identical
       * @param  {Object} range1
       * @param  {Object} range2
       * @return {boolean}
       */
      function rangesAreEqual(range1, range2) {
        return range1.minDate.format() == range2.minDate.format() && range1.maxDate.format() == range2.maxDate.format();
      }

      // Update the slider to reflect the mode setting
      $scope.$watch("mode", function (mode, oldVal) {
        // Only re-initialize the slider if it's already been initialized and the mode has changed
        if (mode && control && mode != oldVal) {
          // Remove any existing controls
          if (control) control.remove();

          initialize(mode);
          updateControlSettings();
        }
      });

      // If the scope is destroyed, make sure the control gets removed
      $scope.$on("$destroy", function () {
        control.remove();
      });

      // If the date range or interval changes, update the control's settings
      $scope.$watchGroup(["maxDateRange", "interval"], function (newVals, oldVals) {
        if (!rangesAreEqual(newVals[0], oldVals[0]) || newVals[1] != oldVals[1]) updateControlSettings();
      });

      // Update the slider when the model changes
      $model.$render = updateControlSettings; // the offender

      // And finally, create the slider for the first time!!
      initialize($scope.mode);
    },
  };
});
